/**
 * Base: forms
 */

var ed = ed || {};

ed.forms = new function () {
    /**
     * Init function
     */
    this.init = function () {
        formLabelEffects();
    };

    /**
     * Label effect for the form elements
     */
    function formLabelEffects() {
        $('.form-group .input').on('focus', function () {
            var parent = $(this).closest('.form-group');

            parent.addClass('focus');
        }).on('blur', function () {
            var parent = $(this).closest('.form-group');

            if ($(this).val() === '') {
                parent.removeClass('focus');
            }
        });
    }
};
